import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { HeaderContainer, HeaderMixin } from '../../shared/styles';
import {
  ActionColumn,
  NameColumn,
  PartnershipColumn,
  MemberCountColumn,
} from './styles';

const NameColumnHeader = styled(NameColumn)`
  ${HeaderMixin}
`;

const PartnershipColumnHeader = styled(PartnershipColumn)`
  ${HeaderMixin}
`;

const MemberCountColumnHeader = styled(MemberCountColumn)`
  ${HeaderMixin}
`;

export default function Header({
  initialOrder, onSort,
}) {
  const [order, setOrder] = React.useState(initialOrder);

  const onClick = key => e => {
    e && e.preventDefault();
    const direction = order === 'desc' ? 'asc' : 'desc';
    setOrder(direction);
    onSort(key, direction);
  };

  const iconClass = {
    'pe-7s-angle-up': order === 'desc',
    'pe-7s-angle-down': order === 'asc',
  };

  return (
    <HeaderContainer>
      <NameColumnHeader onClick={onClick('name')}>
        <span>Name</span>
        <span className={classNames('icon-lw', iconClass)} />
      </NameColumnHeader>
      <PartnershipColumnHeader>Partnership</PartnershipColumnHeader>
      <MemberCountColumnHeader>No. Team Members</MemberCountColumnHeader>
      <ActionColumn />
    </HeaderContainer>
  );
}

Header.propTypes = {
  initialOrder: PropTypes.oneOf(['asc', 'desc']).isRequired,
  onSort: PropTypes.func.isRequired,
};
